import {
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoCustomSelect,
    raikoCustomSelectItemGenerator, RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoGridTwoColumn,
    RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    RaikoTableTitleContainer,
    showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {GameRegistrationService} from "../../../serverService/gameService/GameRegistrationService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {ServerErrorHandler} from "../../../service/errorHandler/ServerErrorHandler";
import {RouteHelper} from "../../../route/RouteHelper";
import {css} from "@emotion/css";
import {GenderDeterminationSelection} from "../../../pages/userInfromation/UserInformation";

export default function GameRegistrantAdditionalInformation({registrantId}) {

    const persianNumbers = [
        'اول',
        'دوم',
        'سوم',
        'چهارم',
        'پنجم',
        'ششم',
    ];

    const [address, setAddress] = useState("");
    const [institutionName, setInstitutionName] = useState("");
    const [educationLevel, setEducationLevel] = useState("");
    const [medicalCondition, setMedicalCondition] = useState("");
    const [hasSmartphone, setHasSmartphone] = useState(true);
    const [culturalCenter, setCulturalCenter] = useState("");


    const [groupName, setGroupName] = useState("");
    const [members, setMembers] = useState([])

    const service = new GameRegistrationService()
    const loading = new LoadingHelper(useLoadingDispatcher())


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getGameRegistrantAdditionalInformationFromServer()
        }
    }, [registrantId]);

    function getGameRegistrantAdditionalInformationFromServer() {
        loading.show()
        service.getGameRegistrantAdditionalInformation(registrantId)
            .then(response => {
                setInstitutionName(response.institutionName)
                setEducationLevel(response.educationLevel)
                setCulturalCenter(response.culturalCenter)
                setHasSmartphone(response.hasSmartphone)
                setMedicalCondition(response.medicalCondition)
                setAddress(response.address)
                setGroupName(response.form && response.form.name ? response.form.name : "")
                setMembers(response.form && response.form.members ? response.form.members : null)
            }).catch(reason => {
            showServerErrorMessage(new ServerErrorHandler(reason).getMessage())
        }).finally(_ => {
            loading.hide()
        })
    }


    return (
        <>
            <RaikoGridOneColumn>
                {
                    members && members.length > 0 ? <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"نفرات"}
                                amount={members && members.length > 0 ? members.length : 0}
                            />
                            <RaikoSimpleInputOutlined
                                labelText={"نام گروه"}
                                value={groupName}
                                setValue={setGroupName}
                                disabled
                            />
                            <RaikoGridOneColumn>
                                {members.map((member, index) => (
                                    <RaikoSectionContainer key={index} title={`عضو ${persianNumbers[index]}`}>
                                        <RaikoGridThreeColumn>
                                            <RaikoSimpleInputOutlined
                                                labelText={"نام"}
                                                value={member.firstName}
                                                setValue={(value) => {
                                                    setMembers((prev) => {
                                                        const newMembers = [...prev];

                                                        newMembers[index] = {
                                                            ...newMembers[index],
                                                            firstName: value,
                                                        };

                                                        return newMembers;
                                                    });
                                                }}
                                                disabled
                                            />
                                            <RaikoSimpleInputOutlined
                                                labelText={`نام خانوادگی `}
                                                value={member.lastName}
                                                setValue={(value) => {
                                                    setMembers((prev) => {
                                                        const newMembers = [...prev];

                                                        newMembers[index] = {
                                                            ...newMembers[index],
                                                            lastName: value,
                                                        };

                                                        return newMembers;
                                                    });
                                                }}
                                                disabled
                                            />
                                            <RaikoMobileInputOutlined
                                                labelText={`شماره همراه `}
                                                value={member.phoneNumber}
                                                setValue={(value) => {
                                                    setMembers((prev) => {
                                                        const newMembers = [...prev];

                                                        newMembers[index] = {
                                                            ...newMembers[index],
                                                            phoneNumber: value,
                                                        };

                                                        return newMembers;
                                                    });
                                                }}
                                                disabled
                                            />
                                            <RaikoNumberInputOutlined
                                                maxLength={"10"}
                                                labelText={`کد ملی `}
                                                value={member.nationalCode}
                                                setValue={(value) => {
                                                    setMembers((prev) => {
                                                        const newMembers = [...prev];

                                                        newMembers[index] = {
                                                            ...newMembers[index],
                                                            nationalCode: value,
                                                        };

                                                        return newMembers;
                                                    });
                                                }}
                                                disabled
                                            />
                                            <RaikoCustomSelect
                                                labelText={`جنسیت `}
                                                value={member.gender}
                                                setValue={(value) => {
                                                    setMembers((prev) => {
                                                        const newMembers = [...prev];

                                                        newMembers[index] = {
                                                            ...newMembers[index],
                                                            gender: value,
                                                        };

                                                        return newMembers;
                                                    });
                                                }}
                                                items={[
                                                    raikoCustomSelectItemGenerator(GenderDeterminationSelection.MALE.key, GenderDeterminationSelection.MALE.name),
                                                    raikoCustomSelectItemGenerator(GenderDeterminationSelection.FEMALE.key, GenderDeterminationSelection.FEMALE.name),
                                                ]}
                                                disabled
                                            />
                                            <RaikoDatePicker
                                                label={`تاریخ تولد `}
                                                date={convertUniversalDateToPersianDate(member.birthDate)}
                                                setDate={(value) => {
                                                    setMembers((prev) => {
                                                        const newMembers = [...prev];

                                                        newMembers[index] = {
                                                            ...newMembers[index],
                                                            birthDate: value,
                                                        };

                                                        return newMembers;
                                                    });
                                                }}
                                                disabled
                                            />

                                        </RaikoGridThreeColumn>
                                    </RaikoSectionContainer>

                                ))}
                            </RaikoGridOneColumn>


                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer> : <RaikoBaseCardContainer>
                        <RaikoSectionContainer title={"اطلاعات تکمیلی"}>
                            <RaikoGridTwoColumn>
                                <RaikoSimpleInputOutlined
                                    labelText={"نام مدرسه"}
                                    value={institutionName}
                                    setValue={setInstitutionName}
                                    disabled
                                />
                                <RaikoSimpleInputOutlined
                                    labelText={"پایه تحصیلی"}
                                    value={educationLevel}
                                    setValue={setEducationLevel}
                                    disabled
                                />
                                <RaikoSimpleInputOutlined
                                    labelText={"فرهنگسرا"}
                                    value={culturalCenter}
                                    setValue={setCulturalCenter}
                                    disabled
                                />
                                <RaikoSimpleInputOutlined
                                    labelText={"دارای گوشی هوشمند"}
                                    value={hasSmartphone ? "آری" : "خیر"}
                                    setValue={setHasSmartphone}
                                    disabled
                                />
                                <RaikoSimpleMultiLineInputOutlined
                                    labelText={"بیماری خاص"}
                                    value={medicalCondition}
                                    setValue={setMedicalCondition}
                                    disabled
                                />
                                <RaikoSimpleMultiLineInputOutlined
                                    labelText={"آدرس"}
                                    value={address}
                                    setValue={setAddress}
                                    disabled
                                />
                            </RaikoGridTwoColumn>
                        </RaikoSectionContainer>
                    </RaikoBaseCardContainer>
                }


            </RaikoGridOneColumn>

        </>

    )

}